import { useState, useCallback, useEffect } from 'react';
import { useCopyToClipboard } from '@sections/chat-gpt/utils/useCopyToClipboard';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';

const COPIED_TEXT = '✨Copied✨';
const COPY_TEXT = 'Copy Text';
const SUFIX = '\n\n\nWritten with Joy — plan your forever, better withjoy.com';

export const useWeddingWritersUnblocker = () => {
  const copyToClipboard = useCopyToClipboard();
  const isMobile = useThemeMediaQuery('below_sm');
  const [loading, setLoading] = useState(false);
  const [showResponse, setShowResponse] = useState(false);
  const [mobileSlideClass, setMobileSlideClass] = useState('slide_hide');
  const [enableTypewritterAnimation, setEnableTypewritterAnimation] = useState(true);
  const [responseText, setResponseText] = useState('');
  const [copyText, setCopyText] = useState(COPY_TEXT);
  const [responseStatus, setResponseStatus] = useState(200);

  const handleOnClose = useCallback(() => {
    setMobileSlideClass('slide_down');
    setShowResponse(false);
  }, []);

  const handleClick = useCallback(() => {
    copyToClipboard((responseText + SUFIX).replace(/<\/br>/g, '\n'));
    setCopyText(COPIED_TEXT);
  }, [copyToClipboard, responseText]);

  const handleDoubleClick = useCallback(() => {
    setEnableTypewritterAnimation(false);
    copyToClipboard(responseText);
  }, [copyToClipboard, responseText]);

  const handleOnSubmit = (data: { loading: boolean; status: number; response: string }) => {
    setCopyText(COPY_TEXT);
    setEnableTypewritterAnimation(true);
    setShowResponse(true);
    setMobileSlideClass('slide_up');
    setLoading(data.loading);
    setResponseStatus(data.status);
    setResponseText(data.response);
  };

  useEffect(() => {
    const html = document.querySelector('html');
    if (html) {
      html.style.overflowY = showResponse || !isMobile ? 'hidden' : 'scroll';
    }
    return () => {
      if (html) {
        html.style.overflowY = 'scroll';
      }
    };
  }, [showResponse, isMobile]);

  return {
    loading,
    copyText,
    responseText,
    responseStatus,
    showResponse,
    mobileSlideClass,
    enableTypewritterAnimation,
    handleOnClose,
    handleOnSubmit,
    handleClick,
    handleDoubleClick,
  };
};
